module.exports = __webpack_public_path__ + "img/remove.98c5ab9d.svg";